import React, { useEffect, useRef } from "react";
import { Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./App.css";
import "./index.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "./assets/fonts/flaticon/flaticon.css";
import "font-awesome/css/font-awesome.min.css";

import Gamerji from "./component/index";
import Esports from "./esports/index";
import BlogDetail from "./esports/BlogDetail";
import AboutUs from "./common/AboutUs";
import TndC from "./common/TndC";
import PrivacyPolicy from "./common/PrivacyPolicy";
import SportsDraft from "./sportsdraft/index";
import CasualGames from "./CasualGames/index";
import CasualGameDetail from "./CasualGames/CasualGameDetail";
import CategoryGameListPage from "./CasualGames/GameListSection";
import PRLinksOnClick from "./component/PRLinksonclick";
import Services from "./Services/index";
import ScrollToTop from "./common/ScrollToTop"; 
const App: React.FC = () => {
  const myRef = useRef<HTMLDivElement | null>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
    });
  }, []);

  useEffect(() => {
    const currentLang = i18n.language;
    const html = document.documentElement;

    html.lang = currentLang;
    html.dir = currentLang === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    <div ref={myRef}>
       {/* <div ref={myRef}> */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Gamerji />} />
        <Route path="/esports" element={<Esports />} />
        <Route path="/blogsdetail" element={<BlogDetail />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/tndc" element={<TndC />} />
        <Route path="/pp" element={<PrivacyPolicy />} />
        <Route path="/sports-draft" element={<SportsDraft />} />
        <Route path="/casual-games" element={<CasualGames />} />
        <Route path="/game/:slug" element={<CasualGameDetail />} />
        <Route path="/category/:slug" element={<CategoryGameListPage />} />
        <Route path="/prlinks" element={<PRLinksOnClick />} />
        <Route path="/service" element={<Services />} />
      </Routes>
    </div>
  );
};

export default App;
